module.exports = __webpack_public_path__ + "static/media/store-plus-icon.a0d709a4.svg";